<ng-content *ngIf="isVisible"></ng-content>

    
